export const getAll = state => state.ageGroups.data
export const getById = (state, ageGroupId) => state.ageGroups.data.find(ageGroup => ageGroup.id === ageGroupId)